<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="stock" />
        <MenuStockList/>
        <StockInOutList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import StockInOutList from '@/components/menuadmin/stock/stocklist/StockInOutList.vue'

export default {
    name:'stockInOut',
    components:{
        HeaderStock,
        MenuStockList,
        StockInOutList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>